module.exports = __webpack_public_path__ + "static/media/wasteConnections.1cbb79a5.png";